export abstract class IconRegistrySingleton {
    protected map: Array<Icon> = [];

    //#region Singleton pattern
    protected static _instance: IconRegistrySingleton;

    protected constructor() {
    }

    public getIcon(key: string): string | null {
        var iconArray = this.map.filter(x => x.key === key);
        if (iconArray.length > 1) {
            throw "Duplicate icons in registry: " + key;
        } else if (iconArray.length) {
            return iconArray[0].value;
        }
        return null;
    }
}

export class Icon {
    constructor(public key: string, public value: string) { }
}